<template>
  <div>
    <el-dialog title="售后" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
      <el-form v-loading="fullscreenLoading" ref="dataForm"  :rules="formRules" :model="form" label-position="right" label-width="100px">
        <template>
          <el-form-item label="认领人员：" prop="customerId" v-if="this.orderSourceType">
            <el-select v-model="form.customerId" value-key="value" placeholder="根据手机号搜索" filterable clearable remote :remote-method="searchUsers" :loading="loading" @change="changeCustomer">
              <el-option v-for="(it,idx) in userList" :label="it.name + (it.pho? '('+it.pho + ')':'')" :key="idx" :value="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：" prop="logisticsNumber" v-if="this.orderSourceType">
            <el-input v-model="form.logisticsNumber" placeholder="请输入快递单号" />
          </el-form-item>
          <el-form-item label="售后方式：" prop="afterMethod">
            <el-radio-group v-model="form.afterMethod">
              <el-radio :label="1">退款（零售价）</el-radio>
              <el-radio :label="2">换货</el-radio>
            </el-radio-group>
            <div>请在确认收到货，检查商品再选择售后方式</div>
          </el-form-item>
          <el-form-item label="售后商品：" required class="width100">
            <div class="table-list mt20">
              <div class="spec-head">
                <div class="sp-col">售后商品</div>
                <div class="sp-col">平台匹配商品</div>
                <div class="sp-col">批次号</div>
                <div class="sp-col">有效期</div>
              </div>
              <div class="spec-item" v-for="(it, idx) in form.goodsListStr" :key="idx">
                <el-form-item class="sp-col" label-width="0">
                  <!-- <el-select style="border:none" v-model="selectItems[idx].id" placeholder="请选择售后商品" popper-class="popperClass" clearable size="small">
                    <el-option v-for="item in detailGoodsList" :key="item.id" :label="item.afterGoodsName" :value="item.id">
                    </el-option>
                  </el-select> -->
                  {{it.oldGoodsName}}*{{it.afterGoodsCount}}
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsListStr[${idx}].platformProductId`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-select style="border:none" filterable v-model="it.platformProductId" placeholder="请选择平台匹配商品" popper-class="popperClass" @change="getGoodsGG(idx)" clearable size="small">
                    <el-option v-for="item in sysGoods" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsListStr[${idx}].batchNumber`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-input v-model="it.batchNumber" placeholder="请输入批次号" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsListStr[${idx}].expirationDate`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-date-picker v-model="it.expirationDate" type="date" placeholder="请选择" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="退款：" prop="refundMoney" :rules="{required: form.afterMethod ===1?true:false,message: '请输入',trigger: 'change',}">
            <el-input v-model="form.refundMoney" placeholder="请输入退款金额" />
          </el-form-item>
          <el-form-item label="换货商品：" required class="width100" v-if="form.afterMethod==2">
            <div class="table-list mt20">
              <div class="spec-head">
                <div class="sp-col">换货商品</div>
                <div class="sp-col">规格</div>
                <div class="sp-col">换货数量</div>
                <div class="sp-col">批次号</div>
                <div class="sp-col">有效期</div>
                <div class="sp-col flex05">操作</div>
              </div>
              <div class="spec-item" v-for="(it, idx) in form.exchangeGoodsListStr" :key="idx">
                <el-form-item class="sp-col" label-width="0" :prop="`exchangeGoodsListStr[${idx}].goodsId`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-select style="border:none" filterable v-model="it.goodsId" placeholder="请选择换货商品" popper-class="popperClass" @change="getGoodsGG(it,idx)" clearable size="small">
                    <el-option v-for="item in sysGoods" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`exchangeGoodsListStr[${idx}].combineId`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-select style="border:none" v-model="it.combineId" placeholder="请选择换货规格" popper-class="popperClass" clearable size="small">
                    <el-option v-for="item in it.huanSpeList" :key="item.id" :label="item.specName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`exchangeGoodsListStr[${idx}].goodsCount`" :rules="{required: true,message: '请填写',trigger: 'change',}">
                  <el-input v-model="it.goodsCount" placeholder="请输入换货数量" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`exchangeGoodsListStr[${idx}].batchNumber`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-input v-model="it.batchNumber" placeholder="请输入批次号" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`exchangeGoodsListStr[${idx}].expirationDate`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-date-picker v-model="it.expirationDate" type="date" placeholder="请选择" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <div class="sp-col oper-icon flex05">
                  <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="form.exchangeGoodsListStr.length > 1"></i>
                  <i class="el-icon-plus" @click="handleAddItem"></i>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="收货地址：" prop="customerAddressId" v-if="form.afterMethod==2">
            <el-select v-model="form.customerAddressId" placeholder="请选择收货地址" clearable>
              <el-option v-for="(it,idx) in userAddrList" :key="idx" :label="it.allAddr" :value="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="补差金额：" prop="repairMoney">
            <el-input v-model="form.repairMoney" placeholder="请输入补差金额" />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="doCreate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import sysGoodsApi from '@/api/sys/sysGoods'
function initFormBean() {
  const formBean = {
    afterIdStr: '',
    logisticsNumber: '',
    afterMethod: 1,
    state: 4,
    customerId: '',
    goodsListStr: [{ id: '', oldGoodsName: '', oldGoodsCount: '', platformProductId: '', batchNumber: '', expirationDate: '' }],
    exchangeGoodsListStr: [{ goodsId: "", combineId: "", goodsCount: "", batchNumber: '', expirationDate: '' }],
    refundMoney: '',
    repairMoney: '',
    customerAddressId: ''
  }
  return formBean
}
export default {
  data() {
    return {
      formRules: {
        customerId: [{ required: true, message: '请选择认领人员', trigger: 'change' }],
        logisticsNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
        afterMethod: [{ required: true, message: '请选择售后方式', trigger: 'change' }],
        customerAddressId: [{ required: true, message: '请选择收货地址', trigger: 'change' }],
      },
      form: initFormBean(),
      formVisible: false,
      detailGoodsList: [],
      selectItems: [],
      sysGoods: [],
      fullscreenLoading: false,
      orderSourceType: 0,    //1 是从待认领售后订单页面来的
      userList: [],
      isRepSub: false,
      userAddrList: []
    };
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
  },
  watch: {

  },
  methods: {
    changeCustomer() {
      let { customerId } = this.form;
      let find = this.userList.find(item => item.id === customerId);
      console.log(find)
      if (find.userId) this.getAddress(find.userId)
    },
    getAddress(userId) {
      goodsOrderApi.getUserAddrList({ userId }).then((res) => {
        let { list } = res.data;
        if (list.length) {
          list.forEach((it) => {
            it.allAddr = it.country + it.province + it.city + it.district + it.detailedAddress;
          });
        }
        this.form.customerAddressId = ''
        this.userAddrList = list;
      });
    },
    handleDeleteItem(index) {
      this.form.exchangeGoodsListStr.splice(index, 1)
    },
    handleAddItem() {
      this.form.exchangeGoodsListStr.push({ goodsId: "", combineId: "", goodsCount: "",batchNumber: '', expirationDate: '' })
    },
    resetForm() {
      this.form = initFormBean()
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getUserList(query)
        }, 500);
      } else {
        this.options = [];
      }
    },
    getUserList(query) {
      goodsOrderApi.getUserList({ state: 1, isDeparted: 0, nameOrPho: query, pageNo: 1, pageSize: 100 }).then((res) => {
        let { list } = res.data;
        let arr = []
        list && list.forEach(item => {
          let { id, name, pho, userId } = item.customer
          arr.push({ id, name, pho, userId })
        })
        this.userList = arr;
      });
    },
    handleAddOrder(id, type) {
      if (type) this.orderSourceType = type;
      this.getDetails(id);

    },
    getDetails(id) {
      this.resetForm()
      this.form.afterIdStr = id;
      goodsOrderApi.getAfterDetail(id).then(({ data }) => {
        let arr = [];
        data.goodsList.forEach(it => {
          arr.push({ id: it.id, afterGoodsCount: it.afterGoodsCount, oldGoodsName: it.afterGoodsName, oldGoodsCount: it.afterGoodsCount, platformProductId: it.platformProductId, batchNumber: it.batchNumber, expirationDate: it.expirationDate });
        })
        this.$set(this.form, 'logisticsNumber', data.deliverInfo || '')
        this.$set(this.form, 'goodsListStr', arr)
        this.formVisible = true;
        if (data.customerId) {
          this.userList = [{ id: data.customerId, name: data.applyInfo && data.applyInfo.name, pho: data.applyInfo && data.applyInfo.pho }]
          this.form.customerId = data.customerId
        } else {
          this.userList = []
          this.form.customerId = ''
        }
        this.getAddress(data.userId)
        this.selectItems = arr;
        this.getGoods();
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    getGoods() {
      sysGoodsApi.getGoodRecomList().then(({ data }) => {
        this.sysGoods = data
      })
    },
    getGoodsGG(it, idx) {
      this.sysGoods.forEach(item => {
        if (it.goodsId == item.id) {
          it.huanSpeList = item.specValueList
        }
      })
    },
    closeDialog() {
      this.fullscreenLoading = false;
      this.formVisible = false;
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          if (this.fullscreenLoading) return;
          if (params.afterMethod === 1) delete params.exchangeGoodsListStr
          params.goodsListStr = JSON.stringify(params.goodsListStr)
          if (params.afterMethod === 2) {
            params.exchangeGoodsListStr.forEach(item => delete item.huanSpeList)
            params.exchangeGoodsListStr = JSON.stringify(params.exchangeGoodsListStr)
          }
          if (this.isRepSub) return
          this.isRepSub = true
          this.fullscreenLoading = true;
          goodsOrderApi.agreeAfter(params).then((data) => {
            this.fullscreenLoading = false;
            this.isRepSub = false
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(data) {
      if (data.code === '0') {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
      } else {
        this.$message.error(data.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.reimbursement {
  padding: 0 50px;
}
.dialog-footer {
  // display: flex;
  // justify-content: center;
  // padding: 20px 0;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  // padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #5dbde7;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;
    &.flex05 {
      flex: 0.5;
    }
    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        .el-input__inner {
          border: none !important;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.popperClass {
  border-color: #fff !important;
}
.spec-item {
  .el-select .el-input {
    box-shadow: none !important;
    border: none !important;
  }
}
</style>